<template>
  <div>
    <div class="search-wrapper">
      <el-card class="box-card" shadow="never" style="border:0">
        <el-form :inline="true">
          <el-form-item>
            <el-autocomplete v-model="keyword" placeholder="请输入厂商/品牌/子车型" :fetch-suggestions="getSmartSearchKeywordAsync" @select="onKeywordSelected" :trigger-on-focus="false" style="width: 600px" @ @keyup.enter.native= "doSearch({id:selectedTypeId,keyword:keyword})">
              <el-select v-model="selectedType" placeholder="请选择" slot="prepend" style="width:100px" @change="onKeywordChanged">
                <el-option label="全部" value="1000" selected></el-option>
                <el-option v-for="type in searchCategories" :key="type.value" :label="type.value" :value="type.id"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="doSearch({id:selectedTypeId,keyword:keyword})"></el-button>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="success" round @click="showAdvancedSearchPanel">高级搜索</el-button>
          </el-form-item>
          <el-form-item>
            <slot name="equipSearchButton"></slot>
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
        <div>
          <span>常用检索条件:</span>
          <el-button type="text" v-for="keyword in commonSearchKeywords" :key="keyword.value" @click.stop="onCommonKeywordSelected(keyword)">{{ keyword.value }}</el-button>
        </div>
      </el-card>
    </div>
    <div v-show="!hasSearchResult" style="padding:6px 20px" v-loading="isLoading">
      <slot name="defaultContent"></slot>
    </div>
    <div class="clear-fix"></div>
    <el-card v-show="hasSearchResult" v-loading="isLoading" style="margin-top:6px;">
      <el-tabs type="card" @tab-click="handleSelectTab" v-model="currentTabName">
        <el-tab-pane label="搜索结果" name="tabSearchResult">
          <span slot="label">
              搜索结果 
              <!--<el-badge class="mark" :value="searchResultCount" /> -->
            </span>
          <VehicleSearchResult @ActiveTab="activeTabByName" :showSelectionButton="!disableResultTab" :resultExclusiveChoice="resultExclusiveChoice">
            <slot name="resultButton" slot="resultButton"></slot>
          </VehicleSearchResult>
        </el-tab-pane>
        <el-tab-pane name="tabSelectionResult" v-if="!disableResultTab">
          <span slot="label">
              已选择列表
              <el-badge class="mark" :value="selectionResultCount" />
            </span>
          <VehicleSelectionResult>
            <slot></slot>
          </VehicleSelectionResult>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <AdvancedVehicleSearch :showDialog.sync="showAdvancedSearch">
      <slot name="buttons" slot="buttons"></slot>
    </AdvancedVehicleSearch>
  </div>
</template>

<script>
  import AdvancedVehicleSearch from "@/components/common/AdvancedSearch.vue";
  import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState
  } from "vuex";
  import {
    clearTimeout
  } from "timers";
  import ApiUrl from "../../store/apiurl";
  import VehicleSearchResult from "@/components/common/SearchResult.vue";
  import VehicleSelectionResult from "@/components/common/SelectionResult.vue";
  import Axios from "axios";
  import {
    all
  } from "q";
  export default {
    name: "commonsearch",
    props: {
      moduleName: {
        type: String,
        required: true
      },
      showCommonAdvancedSearch: {
        type: Boolean,
        default: true
      },
      disableResultTab: {
        type: Boolean,
        default: false
      },
      resultExclusiveChoice: {
        type: Boolean,
        default: false
      }
    },
    components: {
      AdvancedVehicleSearch,
      VehicleSearchResult,
      VehicleSelectionResult
    },
    data() {
      return {
        selectedType: "全部",
        selectedTypeId: "1000",
        keyword: "",
        smartKeywords: [],
        timeout: null,
        showAdvancedSearch: false,
        currentTabName: "tabSearchResult",
        recentScheme: ["1", "2"]
      };
    },
    methods: {
      ...mapActions("commonsearch", [
        "getSearchSchemaAsync",
        "getCommonSearchKeywordAsync"
      ]),
      ...mapMutations("commonsearch", [
        "setDefauleSearchSchema",
        "setCurrentModuleName"
      ]),
      handleSelectTab(tab, event) {
        console.log(tab, event);
      },
      activeTabByName(name) {
        this.currentTabName = name;
      },
      async getSmartSearchKeywordAsync(queryString, cb) {
        if (queryString.trim() == "") return;
        // cb([{value:'华晨宝马'}, {value:'宝马'}]);
        let keywords = this.smartKeywords;
        let results = queryString ?
          keywords.filter(this.createStateFilter(queryString)) :
          keywords;
        try {
          const resp = await this.$axios.post(
            ApiUrl.salesanalysis.getsmartsearchkeyword, {
              id: this.selectedTypeId,
              keyword: queryString
            }
          );
          console.log(resp);
          this.timeout && clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            console.log(resp.data.result);
            cb(resp.data.result);
            this.timeout = null;
          }, 1000);
        } catch (e) {
          console.log(e);
        }
      },
      createStateFilter(queryString) {
        return state => {
          return (
            state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },
      iptChange(){
        alert('ss');
      },
      onKeywordSelected(opt) {
        // alert(opt.value);
      },
      onKeywordChanged(opt) {
        this.selectedTypeId = opt;
      },
      onCommonKeywordSelected(msg) {
        this.keyword = msg.value;
        var label = this.searchCategories.find(element => element.id == msg.key);
        this.selectedTypeId = label.id;
        this.selectedType = label.value;
      },
      // 显示高级搜索
      showAdvancedSearchPanel() {
         this.setDefauleSearchSchema();
        this.showAdvancedSearch = true;
        this.$emit("update:showCommonAdvancedSearch", true);
      },
      // 搜索
      doSearch(params) {
        this.activeTabByName("tabSearchResult");
        var parr = params.keyword.split(/\s+/);
        if(parr == '')
        {
             this.$message({
                message: '请输入搜索内容',
                duration: 2000,   
            });
          return ;
        }

        var post = new Object();
        post[params.id] = parr; //parr.filter(x => x != "");
        this.$store.dispatch("commonsearch/doSearch", post);
        
      },
      // 加载数据
      async loadAll() {
        this.setCurrentModuleName(this.moduleName);
        this.getSearchSchemaAsync();
        this.getCommonSearchKeywordAsync();
      }
    },
    computed: {
      ...mapGetters("commonsearch", [
        "searchCategories",
        "commonSearchKeywords",
        "hasSelectionResult",
        "hasSearchResult",
        "savedSearchSchemas",
        "selectionResult",
        "searchResult",
        "currentModuleName"
      ]),
      ...mapState({
        isLoading: state => state.loadingCount > 0
      }),
      selectionResultCount() {
        return this.selectionResult.length;
      },
      searchResultCount() {
       
        return this.searchResult.length;
      }
    },
    watch: {
      showCommonAdvancedSearch(value) {
        this.showAdvancedSearch = value;
      }
    },
    created() {
      this.setCurrentModuleName(this.moduleName);
    },
    mounted() {
      this.loadAll();
    }
  };
</script>

<style>
  .el-container {
    background-color: #eeeeee;
  }
  .search-wrapper {
    line-height: 24px;
  }
</style>
